import { defineComponent, computed, provide, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import "../../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
import { useConfigProvider } from "../../config-provider/useConfigProvider.js";
import { SIZE_INJECTION_KEY, ORIENTATION_INJECTION_KEY, TYPE_INJECTION_KEY } from "../injectionKeys.js";
import { tabsVariants } from "../styles/index.js";
import { u as useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tabs/TabsRoot.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Tabs",
  props: {
    class: {},
    size: {},
    orientation: {},
    type: {},
    defaultValue: {},
    dir: {},
    activationMode: {},
    modelValue: {},
    unmountOnHide: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props, emits = __emit, delegatedProps = reactiveOmit(props, "class"), forwarded = useForwardPropsEmits(delegatedProps, emits), typeRef = computed(() => props.type), orientationRef = computed(() => typeRef.value === "line" ? "horizontal" : props.orientation), sizeRef = computed(() => props.size);
    provide(SIZE_INJECTION_KEY, sizeRef), provide(ORIENTATION_INJECTION_KEY, orientationRef), provide(TYPE_INJECTION_KEY, typeRef);
    const { dir } = useConfigProvider();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({
      class: unref(cn)(unref(tabsVariants)({ orientation: orientationRef.value }), props.class),
      "data-slot": "tabs"
    }, unref(forwarded), { dir: unref(dir) }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "dir"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Tabs.js.map
